import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../styles/luckydraw.css";
import luckyDrawBg from "../assets/LuckyDraw.webp";

const WinnerReveal = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const winner = location.state?.winner;

  if (!winner) {
    return (
      <div className="winner-error">
        <h2>No winner selected!</h2>

        <button onClick={() => navigate("/lucky-draw")}>
          Go Back
        </button>
      </div>
    );
  }

  return (
    <div
      className="winner-reveal-page"
      style={{
        backgroundImage: `url(${luckyDrawBg})`,
      }}
    >
      <div className="winner-overlay"></div>

      <div className="winner-reveal-content">
        <div className="winner-box">

          <div className="winner-label">
            🏆 TODAY'S LUCKY WINNER 🏆
          </div>

          {/* Winner Name */}
          <div className="winner-name">
            {winner.first_name}
          </div>

          {/* Winner Mobile */}
 <div className="winner-number">
  📱 XXXXXX{winner.mobile?.slice(-4)}
</div>

          <div className="winner-title">
            CONGRATULATIONS! 🎊
          </div>

        </div>

        <button
          className="new-draw-button"
          onClick={() => navigate("/lucky-draw")}
        >
          🎁 Start New Lucky Draw
        </button>
      </div>
    </div>
  );
};

export default WinnerReveal;